import SpinningLogoComponent from "../spinning-logo/spinning-logo.component"
import "./loader.component.css"

const LoaderComponent = () => {
  return (
    <div className="dagger-loader-overlay">{<SpinningLogoComponent />}</div>
  )
}

export default LoaderComponent
